import React, { useMemo, useState, useCallback } from 'react';
import styled from 'styled-components';
import { TextAreaInput } from 'akeneo-design-system';
import noop from 'lodash/noop';
import debounce from 'lodash/debounce';

//_______
type Props = InputProps<string>;

const Root = styled.div`
    textarea {
        height: 100px;
    }
`;

const InputTextarea: React.FC<Props> = (props) => {
    const { value: propsValue = '', onChange = noop } = props;

    const [value, setValue] = useState(propsValue);

    const submitValue = useMemo(() => debounce(onChange, 350), [onChange]);

    const handleChange = useCallback(
        (value: string) => {
            setValue(value);
            submitValue(value);
        },
        [submitValue],
    );

    return (
        <Root role='input-text'>
            <TextAreaInput
                value={value}
                onChange={handleChange}
            />
        </Root>
    );
};

export default InputTextarea;
